<script setup lang="ts">
import { Gift } from "@/types/Gift";
import { useCustomRouter } from "@/utils/router";
import PointCouponCard from "@/components/organisms/mypage/PointCouponCard.vue";

const props = defineProps<{
  giftList: Gift[];
}>();

const { pushIgnoreError } = useCustomRouter();

const onClickExchangeGift = (gift: Gift) => {
  pushIgnoreError({
    name: "ConfirmExchangeCoupon",
    params: { giftId: `${gift.id}` }
  });
};
</script>

<template>
  <div>
    <ul class="coupon-list">
      <li v-for="gift in giftList" :key="gift.id">
        <PointCouponCard
          :gift="gift"
          @click="onClickExchangeGift"
          data-testid="pointCouponCard"
        />
      </li>
    </ul>
    <p class="coupon-note text-gray-05 text-size-12">
      ＊ 新商品続々公開します
    </p>
  </div>
</template>

<style scoped lang="scss">
.coupon-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.coupon-note {
  padding: 0.5rem 0.75rem 0;
}
</style>
